/* --------------- UTILITIES : CSS --------------- */
// shared across all components



// .......... FONT BASELINE .......... //
// baseline font size that all other element sizes will be based off of
// used in index_styles for body font-size and used for pxToEm conversion
const fontSizeBaseline = 16;



// .......... UNIT CONVERSIONS .......... //
// converts pixels in styles to EMs 
// this allows us to create styles as pixels to better match given designs, then convert those to relative units so we can achieve responsive design
let pxToEm = (val) => parseFloat(val) / fontSizeBaseline + "em";
// create some values as rems so they aren't as affected by font size
let pxToRem = (val) => parseFloat(val) / fontSizeBaseline + "rem";
// convert em to pixel (helpful with perctage conversions)
let emToPx = (val) => parseFloat(val) * fontSizeBaseline + "px";
// convert percentages to pixels then to em value (needed for dynamic content sizing based off of content space DOM insertions)
let percToEm = (parSize, elSize) => pxToEm(parseFloat(emToPx(parSize))*(parseFloat(elSize)/100)); //log(parSize, elSize);
// convert style string px to em (used by store.js to convert settings file layouts and content styles from pixels to ems)
let replacePXinStringWithEM = (passedStyle) => {
	// save version of passed style
	let style = passedStyle;
	// if style contains pixels
	if (style.match(/(\d*(\.\d*)?)px/g)) {
		// store individual px in array
		let pxVals = style.match(/(\d*(\.\d*)?)px/g);
		// log(style);
		// log(pxVals);
		// convert to ems
		let emVals = pxVals.map(px => pxToEm(px));
		// log(emVals);
		// for every pixel we found, replace the px in the original style with the converted em (by matching the index of that array)
		pxVals.forEach((val, i) => {
			style = style.replace(val, emVals[i]);
		})
		// log(style);
	}
	return style;
};
// styles (as object) are passed in here and if any of its rules have px values they will be converted to em
let convertStylesPXtoEM = (passedStyles) => {
	// save version of passed styles
	let styles = Object.assign({}, passedStyles);
	// get each style
    Object.entries(styles).forEach((style) => {
        // check if style contains child styles (probably need to make this smarter as this only goes one level deep)
        if (typeof style[1] === "object") {
            Object.entries(style[1]).forEach((nestedStyle) => {
            	// log(nestedStyle[0]);
            	styles[style[0]][nestedStyle[0]] = replacePXinStringWithEM(nestedStyle[1]);
            });
        } else {
            styles[style[0]] = replacePXinStringWithEM(style[1]);
        }
    });
    // log(styles);
    return styles;
};




// .......... CONVERT HEX TO RGB .......... //
// convert hex to rgb (with opacity param adjuster)
const convertHexToRGB = (hex,opacity) => {
    hex = hex.replace('#','');
    let r = parseInt(hex.substring(0,2), 16);
    let g = parseInt(hex.substring(2,4), 16);
    let b = parseInt(hex.substring(4,6), 16);
    let result = 'rgba('+r+','+g+','+b+','+opacity/100+')';
    return result;
};



// .......... COLORS .......... //
const color = {
	black: '#000',
	white: "#fff",
	greyLight: "#F5F5F5",
	greyLightExtra: "#E6E6E6",
	greyMedium: "#D8D8D8",
	greyMediumExtra: '#9B9B9B',
	greyDark: "#808080",
	green: "#4EA808",
	greenLight: '#00B429',
	greenLightExtra: '#adffc0',
	greenMedium: '#80BD3C',
	red: "#E22121",
	redLight: '#ffaaaa',
	redLightExtra: '#ffc6c6',
	pink: "#F01C63",
	pinkMedium: '#E52670',
	blue: "blue",
	blueExtraLight: "#e5f3ff",
	blueLight: '#0094FC',
	blueLightExtra: '#A5D5F2',
	blueMedium: '#1494F4',
	blueMediumDark: "#062B75",
	blueDark: "#042049",
	purple: "purple",
	orange: "orange",
	yellow: "#E8AA0C",

	online: '#00B429',
	offline: '#CB0B0B',

	quiz: '#80BD3C', quizHover: '#3f601c',
	poll: '#1494F4', pollHover: '#042049',
	story: '#E8AA0C', storyHover: '#825f06',
	contest: '#E52670', contestHover: '#660e2f',

	validationError: '#E22121'
};




// .......... BOX SHADOW .......... //
// shadow styles
const boxShadow = {
	blue: { boxShadow: replacePXinStringWithEM(`0 0 20px 0 ${convertHexToRGB(color.blueLight, 90)}`) },
	blueLarge: { boxShadow: replacePXinStringWithEM(`0 0 40px 0 ${convertHexToRGB(color.blueLight, 90)}`) },
	grey: { boxShadow: replacePXinStringWithEM(`0 0 10px 0 rgba(0,0,0,0.15)`) },
	greyLarge: { boxShadow: replacePXinStringWithEM(`0 0 20px 0 rgba(0,0,0,0.15)`) },
	greySmall: { boxShadow: replacePXinStringWithEM(`0 0 2px 0 rgba(0,0,0,0.02)`) }
};





// .......... ANIMATIONS .......... //
const animations = {
	clicked: {
		animationName: 'rubberBand',
	    animationDelay: '0s',
	    animationDuration: '.5s',
	},
	imageHover: {
		animationName: 'pulse',
        animationDelay: '0s',
        animationDuration: '.5s'
	},
	invalid: {
		animationName: 'headShake',
        animationDelay: '0s',
        animationDuration: '.5s'
	}
};




// .......... CENTERING .......... //
// center element absolutely
const centerAbsolutely = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)'
};
const centerVertically = {
	position: 'absolute',
	top: '50%',
	transform: 'translateY(-50%)'
};
const centerHorizontally = {
	position: 'absolute',
	left: '50%',
	transform: 'translateX(-50%)'
};
const removeCenterAbsolutely = {
	position: 'relative',
	top: '0',
	left: '0',
	transform: 'none'
};



// .......... FULL SIZE ELEMENT .......... //
// full width and height
const fullSize = {
	width: '100%',
	height: '100%'
};



// .......... ANSWER SELECT .......... //
const answerSelect = {
	'& .overlay': {
		opacity: '0', // animated by result state
		background: convertHexToRGB(color.blueMedium, 20),
		border: replacePXinStringWithEM(`2px solid ${color.blueLight}`),
		borderRadius: 'inherit',
		width: '100%',
		height: '100%',
		extend: [centerAbsolutely, boxShadow.blue],
		zIndex: '-1',
		transition: 'opacity .2s linear 0s'
	},
	'&.selected-true': {
		'& .overlay': {
			opacity: '1',
			zIndex: '8'
		},
		'& .imageindicator': {
			opacity: '0'
		}
	}
};


// .......... ANSWER ERROR .......... //
const answerError = {
	text: {
		background: convertHexToRGB(color.validationError, 40),
		border: replacePXinStringWithEM(`2px solid ${color.validationError}`)
	},
	image: {
		'& .overlay': {
			background: convertHexToRGB(color.validationError, 40),
			border: replacePXinStringWithEM(`2px solid ${color.validationError}`),
			opacity: '1',
			zIndex: '8',
			boxShadow: 'none'
		}
	}
};



// .......... FIELD HELPER .......... //
const field = {
	outline: 'none',
	backgroundColor: color.white, 
	color: color.greyDark,
	border: replacePXinStringWithEM(`1px solid ${color.greyMedium}`),
	transition: 'all .2s linear 0s',
	'&:hover': {
		extend: boxShadow.grey
	},
	'&:focus': {
		borderColor: color.blueLight,
		extend: boxShadow.blue
	}
};




// .......... CSS IMAGES .......... //
// background image
const cssBGImage = {
	backgroundColor: 'transparent',
	backgroundPosition: '50%',
	backgroundSize: 'contain',
	backgroundRepeat: 'no-repeat'
	// backgroundImage will be placed per unique style
};
// general image settings
const cssImage = {
	backgroundColor: 'transparent',
	backgroundSize: 'contain',
	backgroundRepeat: 'no-repeat',
	backgroundPosition: '50%',
	display: 'inline-block',
	verticalAlign: 'middle',
	'&:hover': {
		transition: 'all .2s linear 0s'
	}
};
// image types
const imageTypes = {
	icon: {
		extend: cssImage
	},
	logo: {
		extend: cssImage
	},
	graphic: {
		extend: cssBGImage
	},
	photo: {
		extend: cssBGImage
	}
};



// .......... BUTTONS .......... //
// button styles
const button = {
    general: {
        background: color.brand,
        border: replacePXinStringWithEM('1px solid #fff'),
        borderRadius: pxToEm(12),
        padding: replacePXinStringWithEM('7px 15px'),
        color: '#fff',
        cursor: 'pointer',
        fontSize: pxToEm(12),
        fontWeight: 'bold',
        textDecoration: 'none',
        transition: 'all .3s linear 0s',

        position: 'absolute',
        bottom: pxToEm(12),
        right: pxToEm(10),
        zIndex: '5',
		outline: 'none',
        '&:hover': {
            background: '#fff',
            color: '#222'
        }
    }
};



// .......... ELLIPSIS .......... //
const ellipsis = {
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis'
};



// .......... DISPLAY TYPES .......... //
// display types
const displayTypes = {
	inline: {
		display: 'inline-block',
		verticalAlign: 'top'
	},
	overlay: {
		// height: '35%',  // this will probably come from settings
		// width: '35%',  // this will probably come from settings
		position: 'absolute',
		zIndex: '4',
		'&.replace': {
			zIndex: '2',
			extend: centerAbsolutely // uses JSS extend functionality (http://cssinjs.org/jss-extend)
		},
		'&.modal': {
			// background: 'rgba(0,0,0,.5)', // this will probably come from settings
			zIndex: '3',
			extend: centerAbsolutely,
			'& $inner': {
				// background: '#fff', // this will probably come from settings
				// height: '70%', // this will probably come from settings
				// width: '70%', // this will probably come from settings
				extend: centerAbsolutely
			}
		},
		'&.outside': {
			'&-top': {
				'&-left': 	{ transform: 'translate(0%, -100%)', top: '0%', left: '0%' },
				'&-center': { transform: 'translate(-50%, -100%)', top: '0%', left: '50%' },
				'&-right': 	{ transform: 'translate(0%, -100%)', top: '0%', right: '0%' }
			},
			'&-right': {
				'&-top': 	{ transform: 'translate(100%, 0%)', top: '0%', right: '0%' },
				'&-center': { transform: 'translate(100%, -50%)', top: '50%', right: '0%' },
				'&-bottom': { transform: 'translate(100%, 0%)', bottom: '0%', right: '0%' }
			},
			'&-bottom': {
				'&-left': 	{ transform: 'translate(0%, 100%)', bottom: '0%', left: '0%' },
				'&-center': { transform: 'translate(-50%, 100%)', bottom: '0%', left: '50%' },
				'&-right': 	{ transform: 'translate(0%, 100%)', bottom: '0%', right: '0%' }
			},
			'&-left': {
				'&-top': 	{ transform: 'translate(-100%, 0%)', top: '0%', left: '0%' },
				'&-center': { transform: 'translate(-100%, -50%)', top: '50%', left: '0%' },
				'&-bottom': { transform: 'translate(-100%, 0%)', bottom: '0%', left: '0%' }
			}
		},
		'&.inside': {
			'&-top': {
				'&-left': 	{ top: '0%', left: '0%' },
				'&-center': { transform: 'translateX(-50%)', top: '0%', left: '50%' },
				'&-right': 	{ top: '0%', right: '0%' }
			},
			'&-center': {
				'&-left': 	{ transform: 'translateY(-50%)', top: '50%', left: '0%' },
				'&-center': { transform: 'translate(-50%, -50%)', top: '50%', left: '50%' },
				'&-right': 	{ transform: 'translateY(-50%)', top: '50%', right: '0%' },
			},
			'&-bottom': {
				'&-left': 	{ bottom: '0%', left: '0%' },
				'&-center': { transform: 'translateX(-50%)', bottom: '0%', left: '50%' },
				'&-right': 	{ bottom: '0%', right: '0%' }
			}
		}
	}
};



// .......... EMBED OVERRIDES (for content cards) .......... //
const embedOverrides = (percentage) => {
	return {
		'& .embed': {
			height: '100%',
			fontSize: `${percentage}%`,
			'& .structureinner': { fontSize: '80%' },
			'& .question': { fontSize: '80%' }
		}
	}
};




// .......... GET CSS PROPERTY .......... //
const getElementCSSProperty = (element, property) => window.getComputedStyle(element, null).getPropertyValue(property);



// .......... MEDIA QUERIES .......... //
// media queries
// http://giona.net/tools/css3-mediaquery-generator/
const mediaQuery = {
	// x axis
	widest: `@media only screen and (min-width:${pxToEm(1400)})`,
	wider: `@media only screen and (min-width:${pxToEm(1200)}) and (max-width:${pxToEm(1400)})`,
	wide: `@media only screen and (min-width:${pxToEm(1080)}) and (max-width:${pxToEm(1200)})`,
	medium: `@media only screen and (min-width:${pxToEm(0)}) and (max-width:${pxToEm(1080)})`,
	// thin: `@media only screen and (min-width:${pxToEm(700)}) and (max-width:${pxToEm(850)})`,
	// thiner: `@media only screen and (min-width:${pxToEm(0)}) and (max-width:${pxToEm(700)})`,
	// y axis
	shortest: `@media only screen and (min-height:${pxToEm(0)}) and (max-height:${pxToEm(700)})`,
	shorter: `@media only screen and (min-height:${pxToEm(700)}) and (max-height:${pxToEm(800)})`,
	short: `@media only screen and (min-height:${pxToEm(800)}) and (max-height:${pxToEm(1000)})`,
};
const embedMediaQuery = {
	wide: `@media only screen and (min-width:${pxToEm(560)})`,
	medium: `@media only screen and (min-width:${pxToEm(400)}) and (max-width:${pxToEm(560)})`,
	thin: `@media only screen and (min-width:${pxToEm(0)}) and (max-width:${pxToEm(270)})`,
	tall: `@media only screen and (max-height:${pxToEm(450)})`,
	short: `@media only screen and (max-height:${pxToEm(250)})`
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export { fontSizeBaseline, pxToEm, pxToRem, percToEm, animations, answerSelect, answerError, field, embedOverrides, convertHexToRGB, color, ellipsis, boxShadow, mediaQuery, embedMediaQuery, imageTypes, button, displayTypes, fullSize, centerAbsolutely, centerVertically, centerHorizontally, removeCenterAbsolutely, replacePXinStringWithEM, convertStylesPXtoEM, getElementCSSProperty };
